module.exports = "<h1 class=\"h3 mb-0\">{{ label }}</h1>\n<hr>\n"